/* Mobile draft filters: keep native form names and Shopify's existing renderer. */
(() => {
  if (window.beMobileFacetsInitialized) return;
  window.beMobileFacetsInitialized = true;
  const mobile = matchMedia('(max-width: 749px)');
  const initialized = new WeakSet();
  const fullyVisibleFilters = new Set(['categories', 'concerns', 'finish', 'formulation', 'hair_type', 'scent_category'].map(key => `filter.p.m.custom.${key}`));
  let serial = 0;
  function enhance() {
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form || !mobile.matches) return;
    const drawer = form.querySelector('menu-drawer');
    if (!drawer) return;
    const disclosure = drawer.querySelector('details');
    const groups = () => drawer.querySelectorAll('.mobile-facets__details');
    if (!initialized.has(form)) {
      initialized.add(form);
      form.classList.add('be-mobile-filters');
      const actions = document.createElement('div');
      actions.className = 'be-mobile-filter-actions';
      actions.innerHTML = '<button type="button" data-be-filter-apply>適用</button><button type="button" data-be-filter-clear>クリア</button>';
      drawer.querySelector('.mobile-facets__inner').append(actions);
      disclosure.addEventListener('toggle', () => {
        if (mobile.matches && disclosure.open) groups().forEach(group => { group.open = true; });
      });
      // Stop before the existing debounced input listener; sorting outside the drawer stays immediate.
      drawer.addEventListener('input', event => {
        if (mobile.matches) {
          event.stopPropagation();
          form.closest('facet-filters-form').refreshDraftFormulationCounts?.(form);
        }
      });
      form.addEventListener('click', event => {
        if (!mobile.matches) return;
        const button = event.target.closest('[data-be-filter-apply], [data-be-filter-clear], [data-be-filter-more]');
        if (!button) {
          if (event.target.closest('.mobile-facets__summary')) event.stopPropagation();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (button.hasAttribute('data-be-filter-more')) {
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? 'ー　閉じる' : '＋　もっと見る';
          panel.classList.toggle('is-expanded', expanded);
          panel.inert = !expanded;
        } else if (button.hasAttribute('data-be-filter-clear')) {
          drawer.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
          drawer.querySelectorAll('price-range input').forEach(input => {
            input.value = input.type === 'range' ? (input.getAttribute('aria-label') === 'から' ? input.min : input.max) : '';
          });
          drawer.querySelectorAll('.range-group').forEach(range => {
            range.style.setProperty('--range-min', '0%');
            range.style.setProperty('--range-max', '100%');
          });
          form.closest('facet-filters-form').refreshDraftFormulationCounts?.(form);
        } else {
          const owner = form.closest('facet-filters-form');
          owner.onSubmitForm(owner.createSearchParams(form));
          disclosure.querySelector('summary').click();
        }
      }, true);
    }
    groups().forEach(group => {
      const list = group.querySelector('.mobile-facets__list');
      if (!list || list.dataset.beMoreReady) return;
      group.querySelectorAll('.be-mobile-filter-extra, [data-be-filter-more]').forEach(element => element.remove());
      list.dataset.beMoreReady = 'true';
      const items = [...list.children].filter(item => !item.hidden);
      const parameter = list.querySelector('input[name]')?.name;
      if (fullyVisibleFilters.has(parameter) || items.length <= 6) return;
      list.classList.add('be-mobile-filter-initial');
      const panel = document.createElement('div');
      panel.className = 'be-mobile-filter-extra';
      panel.id = `be-mobile-filter-extra-${++serial}`;
      const extra = document.createElement('ul');
      extra.className = list.className;
      extra.classList.remove('be-mobile-filter-initial');
      items.slice(6).forEach(item => extra.append(item));
      panel.append(extra);
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('data-be-filter-more', '');
      const expanded = !!extra.querySelector('input:checked');
      button.setAttribute('aria-expanded', String(expanded));
      button.setAttribute('aria-controls', panel.id);
      button.textContent = expanded ? 'ー　閉じる' : '＋　もっと見る';
      panel.classList.toggle('is-expanded', expanded);
      panel.inert = !expanded;
      list.after(panel, button);
    });
  }
  new MutationObserver(enhance).observe(document.documentElement, {childList:true, subtree:true});
  mobile.addEventListener('change', () => {
    document.querySelectorAll('.be-mobile-filter-extra').forEach(panel => { panel.inert = mobile.matches && !panel.classList.contains('is-expanded'); });
    enhance();
  });
  enhance();
})();
